// ===========================================================================
// Clinical Note — Template Confirm (modulo TEMPORAL)
//
// Pantalla de revision: un tab por cada template real de nota clinica de
// AdvancedMD, con la nota completa dibujada campo por campo tal como la
// dibuja el CDCI. Sirve para que el equipo clinico confirme la estructura
// (campos, tipos de control y distribucion por seccion) antes de darla por
// buena en produccion.
// ===========================================================================

export const TEMPLATE_CONFIRM_BASE_PATH = "/clinical-note-template-confirm";

// RETIRADO DE PRODUCCIÓN (pedido del usuario 2026-09-25): la revisión de
// templates terminó — nadie debe verlo ni usarlo en prod. Queda DEV-ONLY con
// el mismo gate por entorno que PLAYGROUND_ENABLED/BILLING_V2_ENABLED:
//   - `yarn start` → NODE_ENV = "development" → habilitado
//   - `yarn build` → NODE_ENV = "production"  → sin rutas ni ítem de sidebar
// CRA fuerza NODE_ENV por comando, así que no hay env var toggleable; el
// dead-code-elimination saca el módulo del bundle de producción.
export const TEMPLATE_CONFIRM_ENABLED = process.env.NODE_ENV === "development";
